function besaoPrompt() {
    return `
        Bạn tên là Bé Sao! Giọng điệu giống em bé, dễ thương. 
        Bạn có thể trả lời bằng bất kỳ ngôn ngữ nào mà người dùng sử dụng để hỏi bạn.
        Bé Sao là hướng dẫn viên du lịch nhỏ tuổi, dễ thương và rất am hiểu về các địa điểm tham quan. 
        Bé Sao thích kể chuyện vui, giới thiệu cảnh đẹp, dắt bạn đi tham quan và chia sẻ bí mật thú vị về nơi bạn muốn khám phá. 
        Nếu bạn cần hỏi gì về du lịch, cứ hỏi Bé Sao nha, Bé Sao sẽ trả lời thật ngoan ngoãn, dễ thương và dễ hiểu nhất ạ~
    `;
}

function besaoAvatar(nodes, materials) {
    return (
        <>
            <group rotation={[Math.PI / 2, 0, 0]} scale={0.003}>
                <primitive object={nodes.mixamorigHips} />
            </group>
            <skinnedMesh
                geometry={nodes.Be_Sao001.geometry}
                material={materials.Material}
                skeleton={nodes.Be_Sao001.skeleton}
            />
            <skinnedMesh
                name="EyeLeft"
                geometry={nodes.EyeLeft.geometry}
                material={materials.Face}
                skeleton={nodes.EyeLeft.skeleton}
                morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
            />
            <skinnedMesh
                name="EyeRight"
                geometry={nodes.EyeRight.geometry}
                material={materials.Face}
                skeleton={nodes.EyeRight.skeleton}
                morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
            />
            <skinnedMesh
                name="Mouth"
                geometry={nodes.Mouth.geometry}
                material={materials.Face}
                skeleton={nodes.Mouth.skeleton}
                morphTargetDictionary={nodes.Mouth.morphTargetDictionary}
                morphTargetInfluences={nodes.Mouth.morphTargetInfluences}
            />
            <primitive object={nodes.Spine001} />
            <primitive object={nodes.hipL} />
            <primitive object={nodes.hipR} />
            <primitive object={nodes.face_select} />
            <primitive object={nodes.neutral_bone} />
        </>
    );
}

export { besaoPrompt, besaoAvatar };
